import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideMenu from "../components/SideMenu";
import AppTheme from '../shared-theme/AppTheme';
import { alpha } from '@mui/material/styles';
import { Alert, Box, Breadcrumbs, Collapse, IconButton, Stack, Typography } from "@mui/material";
import ColorModeIconDropdown from "../shared-theme/ColorModeIconDropdown";
import { Error } from "@mui/icons-material";
import EmailIcon from '@mui/icons-material/Email';
import { useAuth } from '../AuthProvider';

export default function DashboardLayout() {
	const [breadcrumbSections, setBreadcrumbSections] = useState<string[]>([]);
	const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
	const location = useLocation();
	const { currentUser, verifyEmail } = useAuth();

	useEffect(() => {
		const sections: string[] = location.pathname.split("/");
		setBreadcrumbSections(sections);
	}, [location])

	const sendEmailVerification = () => {
		setIsEmailSent(true)
		verifyEmail();

		setTimeout(() => setIsEmailSent(false), 3000);
	}

	return (
		<AppTheme>
			<Box sx={{ display: 'flex' }}>
				{/* ---------- Sidebar ---------- */}
				<SideMenu />
				<Box
					component="main"
					sx={(theme) => ({
						flexGrow: 1,
						backgroundColor: theme.vars
							? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
							: alpha(theme.palette.background.default, 1),
						overflow: 'auto',
					})}
				>
					{/* ---------- Email Verification Check ---------- */}
					<Collapse in={!currentUser?.emailVerified} mountOnEnter unmountOnExit sx={{ margin: "1em" }}>
						<Alert icon={<Error fontSize="inherit" />} severity="error"
							action={
								<Stack spacing={1} direction={"row"} alignItems={"center"}>
									{isEmailSent ? <Typography>Email sent</Typography> : <></>}
									<IconButton
										aria-label="close"
										color="inherit"
										size="small"
										onClick={() => {
											sendEmailVerification();
										}}
									>
										<EmailIcon fontSize="inherit" />
									</IconButton>
								</Stack>
							}>
							<Stack direction={"row"} justifyContent={"space-between"} sx={{ width: "100%" }}>
								<Typography>Your email has not been verified. Please click on the button to the right to request email verification.</Typography>

							</Stack>
						</Alert>
					</Collapse>
					<Stack
						spacing={2}
						sx={{
							alignItems: 'center',
							mx: 3,
							pb: 5,
							// mt: { xs: 8, md: 0 },
							maxWidth: { sm: '100%', md: '1800px' },
							boxSizing: 'border-box'
						}}
					>

						{/* ---------- Topbar ---------- */}
						<Stack
							direction="row"
							sx={{
								// display: { xs: 'none', md: 'flex' },
								width: '100%',
								alignItems: { md: 'center' },
								justifyContent: 'space-between',
								pt: 1.5,
							}}
							spacing={2}
						>
							<Breadcrumbs separator="›" aria-label="breadcrumb">
								<Typography>Dashboard</Typography>
								{breadcrumbSections.map((section: string, index: number) => {
									if (index !== 0 && section !== "app") {
										return (
											<Typography>
												{section.charAt(0).toUpperCase() + section.slice(1)}
											</Typography>
										);
									}
								})}

							</Breadcrumbs>
							<Stack direction="row" sx={{ gap: 1 }}>
								<ColorModeIconDropdown />
							</Stack>
						</Stack>
						{/* ---------- Main ---------- */}
						<Box sx={{ width: 1 }}>
							<Outlet />
						</Box>
					</Stack>
				</Box>
			</Box>
		</AppTheme>
	);
}